import { HttpError } from '@/lib/api/http-error'

export function isAuthError(error: unknown): boolean {
  if (error instanceof HttpError) {
    return error.status === 401
  }

  if (error && typeof error === 'object' && 'data' in error) {
    const code = (error as { data?: { code?: string } }).data?.code
    if (code === 'UNAUTHORIZED') return true
  }

  return false
}
